import 'jquery';

/**
 * @see https://stripe.com/docs/identity/verify-identity-documents
 */
(function ($) {

  let stripeIdentity = $('[data-stripe]'),
    body = $('body'),
    /**
     * call stripe functionality in SDK
     */
    startStripeIdentity = function () {
      // call our stripe method
      // @Todo: build a general method to handle stripe and amazon
      // $(this).parent().addClass('loading');
      stripeIdentity.addClass('loading');
      body.trigger('plenigo.initStripeIdentity', {
        lib: 'https://js.stripe.com/v3/',
        data: stripeIdentity.data('stripe'),
        method: 'check',
      });
    };

  if (!stripeIdentity.length) {
    return;
  }

  // if we're ready to communicate with outer world, we should start stripe process
  stripeIdentity.on('click', startStripeIdentity);

  // we can start process instantly
  if (stripeIdentity.data('clicked')) {
    body.on('plenigo.initialized', startStripeIdentity);
  }

  // receiving stripe result via event from iframe event dispatcher
  body.on('plenigo.stripeResult', function (event, result) {
    if (typeof result.error === 'object' && result.error !== null) {
      // some error message from stripe
      if (typeof result.error.message === 'string') {
        let url = new URL(stripeIdentity.data('check-url'));
        url.searchParams.append('message', result.error.message);
        location.href = url.href;
        return;
        // user closed stripe window
      } else if (typeof result.error.type === 'string' && result.error.type === 'user_action') {
        location.href = stripeIdentity.data('return-to');
        return;
      }
    }
    location.href = stripeIdentity.data('check-url');
  });

}(jQuery));
